module.exports = __webpack_public_path__ + "img/adv_ins_1.d83e2f69.png";